import { createSlice, createSelector } from "@reduxjs/toolkit";

const userAccountSliceSelector = createSlice({
  name: "userAccountSlice",
  initialState: {
    isLoading: false,
    loaderMessage: "",
    isLoadingNewAdd: false,
    isLoadingChangePwd: false,
    Securityqa: [],
    usersAccountList: [],
    userDataById: {},
    phoneResponse:"",
    //Login user Details
    authUser: {},
    otpMode: "Email",
    otpmethod: "",
    verifymessage: "",
    emailMessage: "",
    securityMessage: "",
    verifySecurity: "",
    resetconfirm: ""
  },
  reducers: {
    startGettingUsersList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    startGettingEmailOtpList(state, action) {
      state.otpmethod = action.payload
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setGettingEmailOtpList(state, action) {
      state.emailMessage = action.payload;
    },
    startGettingPhoneOtpList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setGettingPhoneOtpList(state, action) {
      state.phoneResponse = action.payload;
    },
    startVerifySecurityCode(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setVerifySecurityCode(state, action) {
      state.verifymessage = action.payload;
    },
    startSecurityQuestion(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setSecurityQuestion(state, action) {
      state.Securityqa = action.payload;
    },
    startAddSecurityQuestion(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setverifySecurityQuestion(state, action) {
      state.verifySecurity = action.payload;
    },
    startSecurityQuestionForgot(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setSecurityQuestionForgot(state, action) {
      state.securityMessage = action.payload;
    },
    startDeleteUser(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setUsersAccountList(state, action) {
      state.usersAccountList = action.payload;
    },
    startUploadProfile(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    startGettingUsersFilterList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setUsersAccountFilterList(state, action) {
      state.usersAccountList = action.payload;
    },
    startGettingUserById(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setuserDataById(state, action) {
      state.userDataById = action.payload;
    },
    startAddNewUser(state, action) {
      state.isLoadingNewAdd = true;
      state.loaderMessage = "Adding user please wait...";
    },
    completedFetch(state, action) {
      state.isLoading = false;
      state.loaderMessage = "";
    },
    completedNewAdd(state, action) {
      state.isLoadingNewAdd = false;
      state.loaderMessage = "";
    },
    //Auth Action handler
    startUserAuth(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    startRefreshAccessToken(state, action) {
      state.isLoading = true;
    },
    setAuthUser(state, action) {
      state.isLoading = false;
      state.authUser = action.payload;
    },
    otpModeAdded: (users, action) => {
      users.otpMode = action.payload;
    },
    startAuthUserLogout(state, action) {
      state.isLoading = true;
    },
    setUserLogout(state, action) {
      state.authUser = {};
      state.isLoading = false;
    },
    startChangeUserPassword(state, action) {
      state.isLoadingChangePwd = true;
      state.loaderMessage = "Changing password please wait...";
    },
    completedChangeUserPassword(state, action) {
      state.isLoadingChangePwd = false;
      state.loaderMessage = action.message || "";
    },
    startResetPassword(state, action) {
      state.isLoadingChangePwd = true;
      state.loaderMessage = "Changing password please wait...";
    },
    setResetPassword(state, action) {
      state.resetconfirm = action.payload;
    },
    completedResetPassword(state, action) {
      state.isLoadingChangePwd = false;
      state.loaderMessage = action.message || "";
    },
  },
});

export const {
  startGettingUsersList,
  startGettingEmailOtpList,
  setGettingEmailOtpList,
  startGettingPhoneOtpList,
  setGettingPhoneOtpList,
  startDeleteUser,
  setUsersAccountList,
  startGettingUsersFilterList,
  startVerifySecurityCode,
  setVerifySecurityCode,
  startSecurityQuestion,
  setSecurityQuestion,
  setUsersAccountFilterList,
  startAddSecurityQuestion,
  setverifySecurityQuestion,
  startSecurityQuestionForgot,
  startUploadProfile,
  startAddNewUser,
  startGettingUserById,
  setuserDataById,
  startUserAuth,
  startRefreshAccessToken,
  setAuthUser,
  setUserLogout,
  startAuthUserLogout,
  completedFetch,
  completedNewAdd,
  otpModeAdded,
  startChangeUserPassword,
  completedChangeUserPassword,
  startResetPassword,
  setResetPassword,
  completedResetPassword
} = userAccountSliceSelector.actions;
export default userAccountSliceSelector.reducer;

//Selector
const mainReducer = (state) => state.UsersAccount;

export const usersListSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.usersAccountList
);
export const loggedInUserDataSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.authUser
);
export const userDataByIdSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.userDataById
);
export const userPhoneResponseSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.phoneResponse
);
export const isLoadingUsersAccountSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.isLoading
);
export const isLoadingForNewAddSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.isLoadingNewAdd
);
export const loaderMessageSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.loaderMessage
);
export const getOtpMode = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.otpMode
);

export const SecurityQuesListSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.Securityqa
);

export const isLoadingForChangePwdSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.isLoadingChangePwd
);

export const otpmethodSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.otpmethod
);

export const otpmessageSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.verifymessage
);

export const emailOtpSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.emailMessage
);

export const securityOtpSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.securityMessage
);

export const securityverifySelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.verifySecurity
);

export const resetSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.resetconfirm
);